import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import s from './PointsTable.scss';
import PointsTableList from './PointsTableList';

const PointsTable = props => {
  const {
    groupData,
    currentTab,
    isWapView,
    hideTabs = '',
    hideFlags,
    isFifaPage,
    headerHeading,
    isIplPointsTable,
    isMlc,
  } = props;
  const [activeTab, setActiveTab] = useState(currentTab);

  const tabHandler = name => {
    setActiveTab(name);
  };

  useEffect(
    () => {
      setActiveTab(currentTab);
    },
    [currentTab],
  );

  return (
    <div className={s.pointstable}>
      {!hideTabs &&
        !isMlc && (
          <div className={s.tabwapWrap}>
            <div className={s.tabwap}>
              {groupData &&
                Array.isArray(groupData) &&
                groupData.map(tabData => (
                  <>
                    {tabData.name &&
                      tabData.team &&
                      Array.isArray(tabData.team) &&
                      tabData.team.length && (
                        <>
                          <div
                            className={`${s.tab} ${
                              activeTab === tabData.name ? s.active : ''
                            }`}
                            onClick={() => {
                              tabHandler(tabData.name);
                            }}
                          >
                            <span>
                              {tabData?.name &&
                              tabData?.name.toLowerCase().includes('group')
                                ? ''
                                : 'Group'}{' '}
                              {tabData.name}
                            </span>
                          </div>
                        </>
                      )}
                  </>
                ))}
            </div>
          </div>
        )}

      {groupData &&
        Array.isArray(groupData) &&
        groupData.map(tabData => (
          <>
            {tabData.team &&
              Array.isArray(tabData.team) &&
              tabData.team.length && (
                <div className={hideTabs ? s.points_wrap : ''}>
                  {hideTabs &&
                    !isMlc && (
                      <h2>
                        {' '}
                        {isFifaPage ||
                        (!tabData?.name ||
                          (typeof tabData?.name === 'string' &&
                            tabData?.name.toLowerCase().includes('group')))
                          ? ''
                          : 'Group'}{' '}
                        {tabData.name}
                      </h2>
                    )}
                  <PointsTableList
                    tabData={tabData}
                    activeTab={hideTabs ? '' : activeTab}
                    hideFlags={hideFlags}
                    isWapView={isWapView}
                    isFifaPage={isFifaPage}
                    headerHeading={headerHeading}
                    isIplPointsTable={isIplPointsTable}
                  />
                </div>
              )}
          </>
        ))}
      {/* {isWapView && (
        <div className={s.morePointTable}>
          <a href="#">more on points table</a>
        </div>
      )} */}
    </div>
  );
};

PointsTable.propTypes = {
  groupData: PropTypes.arrayOf({}),
  currentTab: PropTypes.string,
  isWapView: PropTypes.bool,
  hideTabs: PropTypes.string,
  hideFlags: PropTypes.string,
  isFifaPage: PropTypes.string,
  headerHeading: PropTypes.arrayOf({}),
  isIplPointsTable: PropTypes.bool,
};
PointsTable.defaultProps = {
  groupData: [],
  currentTab: '',
  isWapView: false,
  hideTabs: '',
  hideFlags: '',
  isFifaPage: '',
  headerHeading: [],
  isIplPointsTable: false,
};

export default React.memo(PointsTable);
